export default __webpack_public_path__ + "static/media/step5.75dd3ff5.webp";